import Fade from './fade';
import FadeDown from './fade-down';

export default {
  fadedown: FadeDown,
  fade: Fade,
};
